module.exports = __webpack_public_path__ + "media/images/icon-separation-af7b507f06e299c09a904d67a681a293.svg";